"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var Icon_1 = tslib_1.__importDefault(require("../Icon"));
var DotsHorizontal = function (props) {
    return ((0, jsx_runtime_1.jsxs)(Icon_1.default, tslib_1.__assign({}, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: 'm82,96c0,-8.00813 6.26801,-14.5 14,-14.5c7.7322,0 14,6.49187 14,14.5c0,8.00835 -6.2678,14.5 -14,14.5c-7.73199,0 -14,-6.49165 -14,-14.5z' }), (0, jsx_runtime_1.jsx)("path", { d: 'm139,96c0,-8.00813 6.26801,-14.5 14,-14.5c7.73219,0 14,6.49187 14,14.5c0,8.00835 -6.26781,14.5 -14,14.5c-7.73199,0 -14,-6.49165 -14,-14.5z' }), (0, jsx_runtime_1.jsx)("path", { d: 'm25,96c0,-8.00813 6.26801,-14.5 14,-14.5c7.73219,0 14,6.49187 14,14.5c0,8.00835 -6.26781,14.5 -14,14.5c-7.73199,0 -14,-6.49165 -14,-14.5z' })] })));
};
/**
 * @deprecated Use Icon from Antd
 * https://ant.design/components/icon/
 */
exports.default = DotsHorizontal;
